import * as React from "react";

import { createSvgIcon } from "@mui/material/utils";

const Achievement14Icon = createSvgIcon(
    <svg
        width="160"
        height="160"
        viewBox="0 0 160 160"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M76.9233 7.7031C78.5228 5.77803 81.4772 5.77803 83.0767 7.7031L97.7427 25.3553C98.6649 26.4652 100.113 26.9924 101.533 26.7349L124.115 22.6397C126.577 22.1931 128.841 24.0922 128.828 26.595L128.717 49.5446C128.71 50.9875 129.48 52.3225 130.733 53.0379L150.664 64.4159C152.838 65.6567 153.351 68.5663 151.733 70.4757L136.895 87.9843C135.963 89.0851 135.695 90.6031 136.195 91.9567L144.149 113.484C145.017 115.832 143.539 118.39 141.073 118.813L118.452 122.688C117.03 122.932 115.849 123.922 115.362 125.281L107.618 146.885C106.774 149.241 103.997 150.251 101.836 148.989L82.0168 137.418C80.7707 136.69 79.2293 136.69 77.9832 137.418L58.1641 148.989C56.0028 150.251 53.2264 149.241 52.3819 146.885L44.6377 125.281C44.1508 123.922 42.97 122.932 41.5477 122.688L18.9274 118.813C16.4605 118.39 14.9833 115.832 15.8507 113.484L23.805 91.9567C24.3051 90.6031 24.0374 89.0851 23.1045 87.9843L8.2672 70.4757C6.64911 68.5663 7.16215 65.6567 9.33571 64.4159L29.2665 53.0379C30.5197 52.3225 31.2904 50.9875 31.2834 49.5446L31.1716 26.595C31.1594 24.0922 33.4227 22.1931 35.8853 22.6397L58.4668 26.7349C59.8867 26.9924 61.3351 26.4652 62.2573 25.3553L76.9233 7.7031Z"
            fill="url(#paint0_linear_5311_1690)"
        />
        <g filter="url(#filter0_i_5311_1690)">
            <path
                d="M76.9233 23.7031C78.5228 21.778 81.4772 21.778 83.0767 23.7031L93.6932 36.4813C94.6154 37.5912 96.0638 38.1184 97.4837 37.8609L113.83 34.8964C116.293 34.4498 118.556 36.3489 118.544 38.8517L118.463 55.4646C118.456 56.9076 119.227 58.2425 120.48 58.9579L134.907 67.1942C137.081 68.4351 137.594 71.3447 135.976 73.2541L125.235 85.9283C124.302 87.0291 124.035 88.5471 124.535 89.9007L130.293 105.484C131.16 107.832 129.683 110.39 127.216 110.813L110.842 113.618C109.419 113.862 108.239 114.852 107.752 116.211L102.146 131.85C101.301 134.206 98.5249 135.216 96.3636 133.954L82.0168 125.578C80.7707 124.85 79.2293 124.85 77.9832 125.578L63.6364 133.954C61.4751 135.216 58.6988 134.206 57.8542 131.85L52.2483 116.211C51.7614 114.852 50.5806 113.862 49.1583 113.618L32.7838 110.813C30.3169 110.39 28.8397 107.832 29.7071 105.484L35.4651 89.9007C35.9652 88.5471 35.6976 87.0291 34.7646 85.9283L24.0241 73.2541C22.406 71.3447 22.9191 68.4351 25.0926 67.1942L39.5203 58.9579C40.7734 58.2425 41.5441 56.9076 41.5371 55.4646L41.4562 38.8517C41.444 36.3489 43.7073 34.4498 46.1699 34.8964L62.5163 37.8609C63.9362 38.1184 65.3846 37.5912 66.3068 36.4813L76.9233 23.7031Z"
                fill="url(#paint1_linear_5311_1690)"
            />
        </g>
        <path
            d="M78.0771 24.6621C79.0457 23.4964 80.8091 23.4596 81.8271 24.5527L81.9229 24.6621L92.5391 37.4395C93.7277 38.8701 95.5528 39.597 97.3848 39.3906L97.751 39.3369L114.098 36.3721C115.589 36.1016 116.963 37.2076 117.04 38.6992L117.044 38.8447L116.963 55.457C116.954 57.3171 117.885 59.047 119.421 60.0664L119.736 60.2607L134.164 68.4971C135.48 69.2485 135.822 70.9787 134.923 72.1709L134.831 72.2842L124.091 84.958C122.888 86.3772 122.49 88.3009 123.012 90.0693L123.128 90.4209L128.886 106.004C129.411 107.425 128.561 108.97 127.105 109.306L126.963 109.334L110.589 112.14C108.756 112.454 107.214 113.671 106.477 115.36L106.34 115.705L100.733 131.344C100.222 132.77 98.5782 133.407 97.248 132.729L97.1201 132.659L82.7734 124.282C81.1671 123.344 79.2037 123.286 77.5527 124.106L77.2266 124.282L62.8799 132.659C61.5712 133.423 59.9021 132.854 59.3193 131.479L59.2666 131.344L53.6602 115.705C53.0325 113.954 51.5666 112.646 49.7744 112.214L49.4111 112.14L33.0371 109.334C31.5435 109.078 30.63 107.57 31.0674 106.142L31.1143 106.004L36.8721 90.4209C37.5168 88.6761 37.2335 86.7324 36.1387 85.249L35.9092 84.958L25.1689 72.2842C24.1892 71.1281 24.4589 69.3851 25.7119 68.5723L25.8359 68.4971L40.2637 60.2607C41.8791 59.3385 42.9117 57.6673 43.0264 55.8271L43.0371 55.457L42.9561 38.8447C42.9487 37.3292 44.2763 36.1676 45.7588 36.3506L45.9023 36.3721L62.249 39.3369C64.0792 39.6687 65.9442 39.0526 67.2148 37.7168L67.4609 37.4395L78.0771 24.6621Z"
            stroke="url(#paint2_linear_5311_1690)"
            strokeWidth="3"
        />
        <g filter="url(#filter1_d_5311_1690)">
            <path
                d="M80 48L100 64V80V96L80 112L60 96V80V64L80 48Z"
                fill="url(#paint3_linear_5311_1690)"
            />
            <path
                d="M80 48L100 64M80 48L60 64M80 48V64M80 112L60 96M80 112L100 96M80 112V96M100 64V80V96M100 64L89.0909 72.4211M60 64V80V96M60 64L70.9091 72.4211M60 96L70.9091 87.5789M100 96L89.0909 87.5789M70.9091 72.4211V87.5789M70.9091 72.4211L80 64M70.9091 87.5789L80 96M89.0909 72.4211V87.5789M89.0909 72.4211L80 64M89.0909 87.5789L80 96"
                stroke="#EB9D19"
                strokeWidth="1.5"
            />
        </g>
        <defs>
            <filter
                id="filter0_i_5311_1690"
                x="23.0752"
                y="22.2593"
                width="117.85"
                height="116.242"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
            >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="BackgroundImageFix"
                    result="shape"
                />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset dx="4" dy="4" />
                <feGaussianBlur stdDeviation="2" />
                <feComposite
                    in2="hardAlpha"
                    operator="arithmetic"
                    k2="-1"
                    k3="1"
                />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
                />
                <feBlend
                    mode="normal"
                    in2="shape"
                    result="effect1_innerShadow_5311_1690"
                />
            </filter>
            <filter
                id="filter1_d_5311_1690"
                x="59.25"
                y="43.0396"
                width="49.5"
                height="73.9209"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
            >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset dx="4" />
                <feGaussianBlur stdDeviation="2" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
                />
                <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_5311_1690"
                />
                <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_5311_1690"
                    result="shape"
                />
            </filter>
            <linearGradient
                id="paint0_linear_5311_1690"
                x1="4"
                y1="4"
                x2="156"
                y2="159.8"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#FBE865" />
                <stop offset="1" stopColor="#F1A718" />
            </linearGradient>
            <linearGradient
                id="paint1_linear_5311_1690"
                x1="20"
                y1="20"
                x2="140"
                y2="140"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#FFE33D" />
                <stop offset="1" stopColor="#FFB62B" />
            </linearGradient>
            <linearGradient
                id="paint2_linear_5311_1690"
                x1="140"
                y1="140"
                x2="38.6727"
                y2="5.89158"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#E69614" />
                <stop offset="1" stopColor="#E69614" stopOpacity="0" />
            </linearGradient>
            <linearGradient
                id="paint3_linear_5311_1690"
                x1="109.091"
                y1="112"
                x2="43.5184"
                y2="56.7756"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#3A50C1" />
                <stop offset="1" stopColor="#8199E6" />
            </linearGradient>
        </defs>
    </svg>,
    "Achievement14Icon",
);

export default Achievement14Icon;
